import { useConst } from "@chakra-ui/react";
import { AsyncReturnType } from "type-fest";

import { TypeaheadService } from "@/services";
import { UseQuerySimpleOptions, useQuery } from "@/services/hooks";
import { gen, repeat } from "@/utils";

type QueryArgs = Parameters<typeof TypeaheadService.getCompanies>[0];
type QueryFnData = AsyncReturnType<typeof TypeaheadService.getCompanies>;
type Error = unknown;

const queryKey = (args: QueryArgs = {}) => ["typeahead", "companies", args];

export const useCompanies = <TData = QueryFnData>(
  args: QueryArgs = {},
  options?: UseQuerySimpleOptions<QueryFnData, Error, TData>
) => {
  const result = useQuery<QueryFnData, Error, TData>(
    queryKey(args),
    () => TypeaheadService.getCompanies(args),
    {
      skeletonData: useConst({
        elements: repeat(gen.typeahead),
        pagination: {
          skip: 0,
          limit: 10,
          total: 2,
        },
      }),
      ...options,
    }
  );

  return result;
};

useCompanies.queryKey = queryKey;
